import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import config from '../../config';
import { useGlobalContext } from '../../GlobalContext';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import { GetById } from '../../service/LevelService';
import { GetByStatusAndLevelId } from '../../service/UserLevelService';

export default function LevelMemberCompletedReport() {
  const {
    isLoading,
    setIsLoading,
    isAppError,
    setAppError,
    appErrorMessage,
    setAppErrorMessage,
    appErrorTitle,
    setAppErrorTitle,
    appErrorMode,
    setAppErrorMode,
    appUser
  } = useGlobalContext();

  //read id from useParams
  const { levelId } = useParams();
  const status = "completed"; 

  const [level, setLevel] = useState({});
  const [name, setName] = useState('');

  const [userLevels, setUserLevels] = useState([]);
  const [keyword, setKeyword] = useState('');
  const [page, setPage] = useState(1);
  const [limit] = useState(10);
  const [totalPages, setTotalPages] = useState(1);

  const fetchLevelById = async () => {
    try {
      setIsLoading(true);
      var response = await GetById(levelId);
      if (response.status === 200) {
        setLevel(response.level);
        setName(response.level.name);
      }
    } catch (error) {
      setAppError(true);
      setAppErrorTitle("Error");
      setAppErrorMessage("Failed to load data");
      setAppErrorMode("error");
    } finally {
      setIsLoading(false);
    }
  };

  const fetchUserLevelList = async (currentPage = page) => {
    try {
      setIsLoading(true);
      const response = await GetByStatusAndLevelId(levelId, status, currentPage, limit, keyword);
      setUserLevels(response.userLevels || []);
      setTotalPages(response.totalPages || 1);
    } catch (error) {
      setAppError(true);
      setAppErrorTitle("Error");
      setAppErrorMessage("Failed to load data");
      setAppErrorMode("error");
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchUserLevelList(page); // Fetch when page changes
  }, [page]);

  React.useEffect(() => {
    if (levelId != null && levelId != undefined && levelId != "") {
      fetchLevelById();
    }
  }, []);

  return (
    <>
      <Helmet>
        <title>Member Level Completed List | {config.appName}</title>
      </Helmet>
      <div className='container'>
        <div className='page'>
          <div className='page-heading'>
            <h1>Member Level Completed Report</h1>
            <span><Link to="/"> Dashboard </Link> / <Link to="/reports/level"> Level Report </Link> / Member Level Completed Report</span>
          </div>
          <div className='page-content'>
            <div className="portal">
              <div className='portal-body'>
                <div className='table-content'>
                  {levelId && name && (
                    <h3>Level : {name}</h3>
                  )}
                  <div className="mobile-scroll">
                  <table className='table table-bordered table-condensed'>
                    <thead>
                      <tr>
                        <th>Sl.no</th>
                        <th>Member Name</th>
                        <th>Member Mobile</th>
                        <th>Remarks</th>
                        <th>Status</th>
                        <th>Achieve</th>
                      </tr>
                    </thead>
                    <tbody>
                      {userLevels && userLevels.length > 0 ? (
                        userLevels.map((userLevel, index) => (
                          <tr key={userLevel.id}>
                            <td>{(page - 1) * limit + index + 1}</td>
                            <td>{userLevel.user.name}</td>
                            <td>{userLevel.user.mobile}</td>
                            <td>{userLevel.remarks}</td>
                            <td>  {userLevel.status.charAt(0).toUpperCase() + userLevel.status.slice(1)}</td>
                            <td>{userLevel.achieve === 1 ? 'Level Achieved' : 'Level Not Achieved'}</td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan="8" className="text-center">No user Levels found</td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                  </div>
                </div>

                {/* Pagination Controls */}
                <div className="pagination-buttons">
                  {page > 1 && (
                    <button
                      className="btn btn-outline-primary"
                      onClick={() => setPage(prev => Math.max(prev - 1, 1))}
                    >
                      Prev
                    </button>
                  )}

                  <span className="align-self-center px-3">Page {page} of {totalPages}</span>

                  {page < totalPages && (
                    <button
                      className="btn btn-outline-primary"
                      onClick={() => setPage(prev => Math.min(prev + 1, totalPages))}
                    >
                      Next
                    </button>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
